import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CellRendererParams } from 'app/shared/components/smart-grid';

@Component({
  selector: 'app-render-created-date',
  standalone: true,
  imports: [CommonModule],
  template: `{{ params.data[params.colDef.field] | date:'short' }}`,
})
export class RenderDateComponent {
  @Input() params!: CellRendererParams<any>;

  agInit(params: CellRendererParams<any>): void {
    this.params = params;
  }
}
